module.exports = __webpack_public_path__ + "static/media/014.63e34f06.jpg";